import { render, staticRenderFns } from "./epms5000.vue?vue&type=template&id=c980c00c&scoped=true"
import script from "./epms5000.vue?vue&type=script&lang=js"
export * from "./epms5000.vue?vue&type=script&lang=js"
import style0 from "./epms5000.vue?vue&type=style&index=0&id=c980c00c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c980c00c",
  null
  
)

export default component.exports